export const LIBRARY_MENU_ITEMS = [
  {
    id: 1,
    title: 'societies',
    href: '/societies',
  },
  {
    id: 2,
    title: 'past conferences',
    href: '/library/past-conferences',
  },
  {
    id: 3,
    title: 'presentations',
    href: '/library',
  },
  {
    id: 4,
    title: 'speakers',
    href: '/speakers',
  },
];

export interface INavigationItems {
  id: number | string;
  href: string;
  title: string;
}

/**
 * Width of the mobile navigation dropdowns. Other rows in the drawer size to this
 * so their right edge lines up with the dropdown chevrons.
 */
export const MOBILE_NAV_WIDTH = 292;

/**
 * Horizontal gutter inside the drawer. The same value both sides, so the chevrons
 * and the Premium label share a right edge and line up with the text on the left.
 */
export const MOBILE_NAV_PADDING_X = { base: '20px', md: '40px' };

/** Chakra's default horizontal padding on AccordionPanel, which wraps a nested dropdown. */
const ACCORDION_PANEL_PADDING = 16;
/** How far a second-level arrow sits inside the first-level one. */
const NESTED_ARROW_STEP = 28;

/**
 * Right padding for a second-level dropdown button, so its arrow steps inward from the
 * first-level arrow rather than out past it - that offset is what signals the nesting.
 *
 * Derived from MOBILE_NAV_PADDING_X rather than written out, because the two drifting
 * apart is what put the nested arrow on the wrong side at `md` in the first place. The
 * panel's own padding is subtracted since it stacks with the button's.
 */
export const MOBILE_NAV_NESTED_PADDING_RIGHT = Object.fromEntries(
  Object.entries(MOBILE_NAV_PADDING_X).map(([breakpoint, padding]) => [
    breakpoint,
    `${parseInt(padding, 10) + NESTED_ARROW_STEP - ACCORDION_PANEL_PADDING}px`,
  ])
) as typeof MOBILE_NAV_PADDING_X;
